<mf-row>
  <mf-field-text
    [label]="gridFilter.header"
    [(ngModel)]="value"></mf-field-text>
</mf-row>
